import { render } from "./hero.vue?vue&type=template&id=3299f170&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=3299f170&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3299f170"

export default script